var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleOrangeTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66669C5.41669 1.66669 1.66669 5.41669 1.66669 10C1.66669 14.5834 5.41669 18.3334 10 18.3334C14.5834 18.3334 18.3334 14.5834 18.3334 10C18.3334 5.41669 14.5834 1.66669 10 1.66669ZM13.5 8.58335L9.50002 12.5834C9.16669 12.9167 8.66669 12.9167 8.33335 12.5834L6.50002 10.75C6.16669 10.4167 6.16669 9.91669 6.50002 9.58335C6.83335 9.25002 7.33335 9.25002 7.66669 9.58335L8.91669 10.8334L12.3334 7.41669C12.6667 7.08335 13.1667 7.08335 13.5 7.41669C13.8334 7.75002 13.8334 8.25002 13.5 8.58335Z",
    fill: "#E87663"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOrangeTick);
export default __webpack_public_path__ + "static/media/circle-orange-tick.8c8c90c20a7d56fae3c5fec4f7ddedab.svg";
export { ForwardRef as ReactComponent };